import { instance } from '../instance'

export const getUser = async () => {
  return instance.get('/v2/user')
}
